const boxesCount = 9;
const minSize = 40;

const baseOrigins = {
  top: 'top',
  left: 'left',
  right: 'right',
  bottom: 'bottom',
};

const origins = {
  ...baseOrigins,
  topLeft: `${baseOrigins.top}-${baseOrigins.left}`,
  topRight: `${baseOrigins.top}-${baseOrigins.right}`,
  bottomLeft: `${baseOrigins.bottom}-${baseOrigins.left}`,
  bottomRight: `${baseOrigins.bottom}-${baseOrigins.right}`,
};

/*
  badge's direction is changing
  the neccesity to change the transform's
  x and y coordinates depend on the exact direction
 */

const directions = [
  {
    origin: origins.top,
    scales: [0, 1],
  },
  {
    origin: origins.topRight,
    scales: [1, 1],
  },
  {
    origin: origins.right,
    scales: [1, 0],
  },
  {
    origin: origins.bottomRight,
    scales: [1, 1],
  },
  {
    origin: origins.bottom,
    scales: [0, 1],
  },
  {
    origin: origins.bottomLeft,
    scales: [1, 1],
  },
  {
    origin: origins.left,
    scales: [1, 0],
  },
  {
    origin: origins.topLeft,
    scales: [1, 1],
  },
];

const optionsConfig = [
  { direction: 'top-left', nameOfClass: 'optionLeftTop' },
  { direction: 'top', nameOfClass: 'optionMiddleTop' },
  { direction: 'top-right', nameOfClass: 'optionRightTop' },
  { direction: 'right', nameOfClass: 'optionMiddleRight' },
  { direction: 'bottom-right', nameOfClass: 'optionRightBottom' },
  { direction: 'bottom', nameOfClass: 'optionMiddleBottom' },
  { direction: 'bottom-left', nameOfClass: 'optionLeftBottom' },
  { direction: 'left', nameOfClass: 'optionMiddleLeft' },
];

export { optionsConfig, directions, boxesCount, origins, minSize };
